<template>

    <div>
        <template>
            <div class="text-center">
                <v-dialog
                        v-model="addNumber"
                        width="500"
                ><template v-slot:activator="{ on, attrs }">
                    </template>
                    <v-card>
                        <v-card-text>
                            <div class="pt-5">
                                <v-text-field class="pt-5" label="افزودن شماره دلخواه" clearable
                                              clear-icon="mdi-close-circle-outline" v-model="customNumber" type="number"
                                              dense>
                                </v-text-field>
                            </div>
                        </v-card-text>

                        <v-card-actions>
                            <v-btn
                                    color="error"
                                    text
                                    @click="addNumber = false"
                            >
                                بستن
                            </v-btn>
                            <v-btn
                                    color="success"
                                    text
                                    @click="addCustomNumber(customNumber)"
                            >
                                ثبت شماره
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </div>
        </template>
        <v-tabs
                color="deep-purple accent-4"
                centered
                icons-and-text>
            <v-tab :key="index" v-for="(itemName,index) in chargeMount" v-if="Object.keys(result[index]).length > 0">
                <mci v-if="index === 'mci' && Object.keys(result[index]).length > 0"></mci>
                <rtl v-else-if="index === 'mtn' && Object.keys(result[index]).length > 0"></rtl>
                <mtn v-else-if="index=== 'rtl' && Object.keys(result[index]).length > 0"></mtn>
            </v-tab>

            <v-tab-item
                    v-for="(itemCount,index) in chargeMount"
                    :ref="index"
                    v-if="Object.keys(result[index]).length > 0"
            >
                <v-container fluid :key="index">
                    <div class="row">
                        <div class="col-md-8">
                            <v-btn text class="mx-5" color="info" v-model="addNumber" @click="addNumber = true">
                                <i class="fa fa-plus ml-2 text-info"></i>
                                افزودن شماره دلخواه
                            </v-btn>
                        </div>
                        <div class="col-md mt-3" v-if="currentAmounts[index] >  0">
                            <span class="badge badge-info font-weight-bold" style="font-size: 8.5pt">
                                {{ currentAmounts[index]|currency }} ﷼
                            </span>
                        </div>
                    </div>
                    <div class="text-center mb-4 mt-4">
                        <div class="mb-3">
                            <v-chip
                                    close
                                    color="pink darken-3"
                                    outlined
                                    label
                                    :key="index"
                                    class="mx-1 mt-1"
                                    v-for="numbers in result[index]"
                                    @click:close="selected_Num.splice(selected_Num.indexOf(numbers),1)"
                            >{{ numbers }}
                            </v-chip>
                        </div>
                        <v-btn @click="priceEnter(item.price,index,item.realPrice)" :key="index"
                               class="mx-1 mt-1 text-white" color="pink accent-4"
                               v-for="item in chargeMount[index]"
                               :value="item.realPrice"> {{ item.price|currency }} ﷼
                        </v-btn>
                    </div>
                    <v-btn @click="buyCharge" class="btn-buy float-left mr-12">
                        <span class="fa fa-shopping-bag ml-1" style="font-size: 1.3rem"></span>خرید</v-btn>
                </v-container>
            </v-tab-item>
        </v-tabs>
    </div>
</template>

<script>
import Mci from "@/view/pages/numbers/mci";
import Mtn from "@/view/pages/numbers/mtn";
import Rtl from "@/view/pages/numbers/rtl";
import {Bus} from "@/main";
import Swal from "sweetalert2";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";

export default {
    name: "chargeNumbers",
    components: {ButtonTempl, Rtl, Mtn, Mci},
    props: {
        selected_Num: {
            default: []
        }
    },
    data() {
        return {
            addNumber: false,
            chargeMount: [],
            tab: '',
            customNumber: '',
            chosenPrice: {},
            result: [],
            currentAmounts: {
                mci: 0,
                mtn: 0,
                rtl: 0
            }
        }
    },
    methods: {
        getChargeMount() {
            const vm = this;
            $.ajax({
                url: `${url}/setting/charges`,
                type: 'GET',
                fn: this.getChargeMount,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: function (data) {
                    vm.chargeMount = data.data
                }
            })
        },
        priceEnter(price,type,realPrice) {
            this.chosenPrice[type]["amount"] = { price:price,realPrice:realPrice }
            this.currentAmounts[type] = Number(price);
        },
        guessOperator(numbers) {
            const collection = {mtn: [], mci: [], rtl: []};
            const mtn = new RegExp('^(0933|0930|0935|0936|0937|0938|0939|0901|0902|0903|0904|0905|0941|0999)');
            const mci = new RegExp('^(0990|0991|0992|0993|0994|0911|0912|0913|0914|0915|0916|0917|0918|0910)');
            const rtl = new RegExp('^(0921|0920|922)');

            let phones = {
                mtn: [],
                rtl: [],
                mci: [],
            };

            numbers.forEach((item) => {
                if (mtn.exec(item)) {
                    collection.mtn.push(item)
                    phones.mtn.push(item);
                }

                if (mci.exec(item)) {
                    collection.mci.push(item);
                    phones.mci.push(item);
                }

                if (rtl.exec(item)) {
                    collection.rtl.push(item);
                    phones.rtl.push(item);
                }
            });

            Object.keys(phones).forEach((item) => {
                if (phones[item].length > 0)
                    this.chosenPrice[item] = {
                        phones: phones[item],
                        amount: 0
                    };
            });

            return collection;
        },
        addCustomNumber(number) {
            this.selected_Num.push(number)
            this.addNumber = false
        },
        buyCharge() {
            $.ajax({
                url: `${url}/shop/charges`,
                type: 'POST',
                fn: this.buyCharge,
                headers: {
                    ACCEPT: 'application/json',
                    Authorization: Token,
                    "Content-Type": 'application/json'
                },
                data: JSON.stringify(this.chosenPrice),
                msg:true,
            })
        }
    },
    watch: {
        selected_Num: {
            handler: function (value) {
                this.result = this.guessOperator(value);
            },
            deep: true
        },
    },
    mounted() {
        this.result = this.guessOperator(this.selected_Num);
        this.getChargeMount();
    }
}
</script>



